/**
 * header constants
* @author Faisal Siddiqui <hafizfaisalsiddiqui2@gmail.com>
* @comapany Voktro
 */

export class ThemeHeader {
    public static profile: string = 'Profile';
    public static profile_url: string = '/profile';
    public static login: string = 'Login';
    public static logout: string = 'Log Out';
}